// Footer del PDF: razón social retirada a petición del cliente (mantenida
// comentada como referencia), columna flexible vacía y contador de páginas.
export function buildFooter() {
  return (currentPage: number, pageCount: number) => ({
    margin: [30, 0, 40, 0],
    columns: [
      // Texto de razón social/dirección retirado a petición del cliente.
      // {
      //   text: "INDO OPTICAL S.L.U • Avda. Alcalde Barnils, 72 - 08174 Sant Cugat del Vallès - Barcelona",
      //   fontSize: 8,
      //   width: "*",
      //   margin: [0, 0, 0, 10],
      // },
      { text: "", width: "*" },
      {
        text: `${currentPage} / ${pageCount}`,
        fontSize: 9,
        alignment: "right",
        width: "auto",
      },
    ],
  });
}
